
module.exports = function getResource(label, vars = []) {
    const resources = { backToLists: 'Back to Lists' };
    return resources[label];
};
